module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑' : '新增') + "商品")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('z-input', {
    attrs: {
      "title": "商品名称",
      "isMust": true
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.face,
      "on-success": _vm.handleFaceSuccess
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(2), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-num": 5,
      "file-list": _vm.params.album_list,
      "on-success": _vm.handleAlbumSuccess
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('z-select', {
    staticClass: "m-t-20",
    attrs: {
      "title": "所属分类",
      "options": _vm.typeList,
      "isMust": true
    },
    model: {
      value: (_vm.params.goods_type_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "goods_type_id", $$v)
      },
      expression: "params.goods_type_id"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-20",
    attrs: {
      "title": "商品原价",
      "isMust": true,
      "type": "number"
    },
    model: {
      value: (_vm.params.list_price),
      callback: function($$v) {
        _vm.$set(_vm.params, "list_price", $$v)
      },
      expression: "params.list_price"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-20",
    attrs: {
      "title": "商品售价",
      "isMust": true
    },
    model: {
      value: (_vm.params.price),
      callback: function($$v) {
        _vm.$set(_vm.params, "price", $$v)
      },
      expression: "params.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('div', [_c('span', [_vm._v("属性名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.standard.title),
      expression: "params.standard.title"
    }],
    staticClass: "input b-r-3 input-width m-l-10",
    attrs: {
      "type": "text",
      "placeholder": "如：颜色（只能有一个）",
      "maxlength": "15/"
    },
    domProps: {
      "value": (_vm.params.standard.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params.standard, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('span', [_vm._v("属性值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.standardValue),
      expression: "standardValue"
    }],
    staticClass: "input b-r-3 input-width m-l-10",
    attrs: {
      "type": "text",
      "placeholder": "如：红色、黑色（可有多个）",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.standardValue)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleBlur()
      },
      "blur": function($event) {
        return _vm.handleBlur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.standardValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "key-list"
  }, [_c('ol', {
    staticClass: "fx fx-wrap"
  }, _vm._l((_vm.params.standard.items || []), function(item, index) {
    return _c('li', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          return _vm.handleDelInputStandard(index)
        }
      }
    })])
  }), 0)])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-30 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": function($event) {
        return _vm.handleValidation()
      }
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")])]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商品封面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _c('div', {
    staticClass: "pic-tips"
  }, [_vm._v("建议尺寸：640*600；文件大小建议300KB以内")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商品图集")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _c('div', {
    staticClass: "pic-tips"
  }, [_vm._v("建议尺寸：640*600；文件大小建议300KB以内；最多五张图片")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5 m-t-10"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("规格属性")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx m-t-5"
  }, [_c('div', {
    staticClass: "pic-tips fx-fill"
  }, [_vm._v("Tips：属性名最多15个字符")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _c('div', {
    staticClass: "pic-tips fx-fill"
  }, [_vm._v("Tips：属性值最多10个字符。（输入完成后按回车即可完成添加）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_c('p', {
    staticClass: "title fx fx-shrink w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商品详情")])]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill edit-cont"
  }), _c('div', {
    attrs: {
      "id": "content",
      "placeholder": "请在这里输入内容"
    }
  }), _vm._v(" "), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-eb4d54bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vmall/GoodsEdit.vue
// module id = 891
// module chunks = 0